import useLocalization, { SupportedLocale } from '@/assets/localizations';
import { useAppContext, useAppStore } from '@/store';
import {
  useGetGuestUserQuery,
  usePatchGuestUserByIdMutation,
} from '@/store/services/userApi';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { StyleSheet, View } from 'react-native';

import { RadioButton } from 'react-native-paper';

export default function LanguageSelectorContent({
  onClose,
}: {
  onClose: () => void;
}) {
  const { languages } = useLocalization();
  const { setLocale, locale } = useAppContext();
  const [patchGuestUserById] = usePatchGuestUserByIdMutation();
  const { data: guest } = useGetGuestUserQuery();

  const { company } = useAppStore();
  const handleLanguageChange = async (selectedLanguage: string) => {
    const storageKey = company?.id ? `locale-${company.id}` : 'locale';
    await AsyncStorage.setItem(storageKey, selectedLanguage);

    if (guest?.id) {
      patchGuestUserById({
        ...guest,
        locale: selectedLanguage,
      });
    } else {
      setLocale(selectedLanguage as SupportedLocale);
    }

    onClose();
  };

  return (
    <View style={styles.bodyContainerStyle}>
      <RadioButton.Group onValueChange={handleLanguageChange} value={locale}>
        {languages.map((language, index) => (
          <RadioButton.Item
            key={index}
            style={styles.optionStyle}
            label={language.name}
            value={language.locale}
          />
        ))}
      </RadioButton.Group>
    </View>
  );
}

const styles = StyleSheet.create({
  bodyContainerStyle: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    width: '100%',
  },
  optionStyle: {
    width: '100%',
    paddingTop: 8,
    paddingRight: 24,
    paddingBottom: 8,
    paddingLeft: 16,
    height: 56,
  },
});
